// HIGH SPEED SHOP — Search
import { debounce, escapeHtml, storeUrl } from './hs_utils';

export function initSearch() {
	const input = document.getElementById('hs-search-input');
	const results = document.getElementById('hs-search-results');
	if (!input || !results) return;

	const doSearch = debounce(function (query) {
		if (query.length < 2) {
			results.style.display = 'none';
			return;
		}

		frappe.call({
			method: 'high_speed_shop.high_speed_shop.api.catalog.search',
			args: { query: query },
			callback: function (r) {
				if (!r.message) {
					results.style.display = 'none';
					return;
				}

				let html = '';
				const items = r.message || [];

				if (items.length === 0) {
					html = `<div class="hs-search-result-item"><span class="hs-search-result-name">${__('No results found')}</span></div>`;
				} else {
					items.slice(0, 8).forEach(function (item) {
						const img = item.image
							? `<img src="${escapeHtml(item.image)}" alt="">`
							: '';
						html += `<a href="${storeUrl('/product/' + encodeURIComponent(item.item_code || ''))}" class="hs-search-result-item">
							${img}
							<div>
								<div class="hs-search-result-name">${escapeHtml(item.item_name || item.name)}</div>
							</div>
						</a>`;
					});

					html += `<a href="${storeUrl('/shop')}?search=${encodeURIComponent(query)}" class="hs-search-result-item" style="justify-content:center; color: var(--hs-primary); font-weight: 500;">
						${__('View all results')}
					</a>`;
				}

				results.innerHTML = html;
				results.style.display = 'block';
			},
		});
	}, 300);

	input.addEventListener('input', function () {
		doSearch(this.value.trim());
	});

	// Close on click outside
	document.addEventListener('click', function (e) {
		if (!e.target.closest('.hs-search-box')) {
			results.style.display = 'none';
		}
	});

	// Close on Escape
	input.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			results.style.display = 'none';
			input.blur();
		}
	});
}
